"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggedInState = void 0;
var LoggedInState;
(function (LoggedInState) {
    LoggedInState["SOFT"] = "soft";
    LoggedInState["HARD"] = "hard";
    LoggedInState["LOGGED_OUT"] = "logged_out";
    LoggedInState["NONE"] = "";
})(LoggedInState = exports.LoggedInState || (exports.LoggedInState = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/authorize/interfaces.js
// module id = 1337
// module chunks = 11